import { z } from 'zod';
import { createModel } from '../../common';
import { partyRoleSchema } from '../../common/party.schema';
import { UserSchema } from '../user/user.model';
import { adminPermissionSchema } from './admin-user.permissions.model';
import { emailSchema } from '../../validation';

/**
 * AdminUser schema extends UserSchema with admin-specific fields.
 *
 * Overrides `roles` (from `UserSchema`) to be optional and default to
 * `[]`. Hero staff / super-admin users are NOT network parties, so they
 * have no {@link partyRoleSchema} entry — they are tracked via the
 * document's `creator` snapshot instead.
 */
export const AdminUserSchema = createModel({
  ...UserSchema.data.shape,
  email: emailSchema,
  roles: z.array(partyRoleSchema).default([]),
  /** Admin user permissions array for granular access control */
  permissions: z.array(adminPermissionSchema).default([]),
});

/** Admin user db model */
export type AdminUser = z.infer<typeof AdminUserSchema.model>;
export type AdminUserData = z.infer<typeof AdminUserSchema.data>;
export type AdminUserPartial = z.infer<typeof AdminUserSchema.partial>;
